import { delCookie, getCookie } from 'ava-util/dist/cookie';
import {
    COOKIE_LOCALE,
    COOKIE_LANG,
    COOKIE_COUNTRY,
    COOKIE_CURRENCY,
    COOKIE_ACCESS_TOKEN,
    COOKIE_LOGIN_TOKEN,
    COOKIE_IS_GUEST_USER,
    COOKIE_DEBUG_TRANS,
    COOKIE_VARIANT_NUMS_ITEMS,
    COOKIE_BUY_NOW_DATA,
    COOKIE_CART_SELECTED_IDS,
    COOKIE_LAST_ORDER_ID,
} from 'base/config/constant';

const suffixes = [
    'vivosun.com',
    'vivohome.com',
    'flex-star.com',
    'matrix-lighting.com',
];

export function clearCookie(name: string, suffix: string): boolean {
    if (name.length === 0) {
        return false;
    }
    let cookie = name + '=' + encodeURIComponent('');
    cookie += ';path=/';

    const expiresDate = new Date();
    expiresDate.setTime(expiresDate.getTime() + (-1 * 24 * 3600 * 1000));
    const expiresTrans = expiresDate.toUTCString();
    cookie += ';expires=' + expiresTrans;
    cookie += ';domain=.' + suffix;
    cookie += ';samesite=lax';

    try {
        document.cookie = cookie;
        return true;
    } catch (err) {
        console.log('cookie is disabled');
        return false;
    }
}

// 旧 Cookie 有效期为 365 天, 上线一年后可删除这段代码
export function clearOldCookies() {
    const host = window.location.host;
    if(!host.startsWith('localhost') && !suffixes.includes(host)) {
        suffixes.push(host);
    }
    // 删除 domain 为 .xxx.com 的旧 Cookie
    suffixes.forEach(suffix => {
        if (host.endsWith(suffix)) {
            clearCookie(COOKIE_LOCALE, suffix);
            clearCookie(COOKIE_LANG, suffix);
            clearCookie(COOKIE_COUNTRY, suffix);
            clearCookie(COOKIE_CURRENCY, suffix);
            clearCookie(COOKIE_ACCESS_TOKEN, suffix);
            clearCookie(COOKIE_LOGIN_TOKEN, suffix);
            clearCookie(COOKIE_IS_GUEST_USER, suffix);
            clearCookie(COOKIE_DEBUG_TRANS, suffix);
            clearCookie(COOKIE_VARIANT_NUMS_ITEMS, suffix);
            clearCookie(COOKIE_BUY_NOW_DATA, suffix);
            clearCookie(COOKIE_CART_SELECTED_IDS, suffix);
            clearCookie(COOKIE_LAST_ORDER_ID, suffix);
        }
    });

    // 删除过渡 Cookie
    if (getCookie('COUNTRY_2')) {
        delCookie('NEXT_LOCALE_2');
        delCookie('LANGUAGE_2');
        delCookie('COUNTRY_2');
        delCookie('CURRENCY_2');
        delCookie('ACCESS_TOKEN_2');
        delCookie('LOGIN_TOKEN_2');
        delCookie('IS_GUEST_USER_2');
        delCookie('DEBUG_TRANS_2');
        delCookie('VARIANT_NUMS_ITEMS_2');
        delCookie('BUY_NOW_DATA_2');
        delCookie('CART_SELECTED_IDS_2');
        delCookie('LAST_ORDER_ID_2');
    }
}